import { useEffect } from "react";
import { useSelector } from "react-redux";
import Chart from "react-apexcharts";
import { useDashboardStore } from "../../../hooks";
import { LoadingData, ErrorMessage } from "../../ui";
import { optionsEventsByAvailabilityProcedures } from "../../data";

export const AvailabilityValorationEventsChart = () => {
  // Datos del hook ----------------------------------------//
  const { isLoading, data, errorMessage } = useSelector(
    (state) => state.dashboard.eventsByAvailabilityValorations
  );

  const { getDataEventsByAvailabilityValorations } = useDashboardStore();

  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (!data) {
      getDataEventsByAvailabilityValorations();
    }
  }, [data, getDataEventsByAvailabilityValorations]);

  return (
    <div className="card shadow border-0 p-4 h-100">
      {isLoading && <LoadingData />}
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      {data && (
        <>
          <h6 className="align-items-center mb-0">
            Ocupación calendarios de valoración
          </h6>
          <Chart
            options={optionsEventsByAvailabilityProcedures}
            series={data.series}
            type="bar"
            width="100%"
            height={350}
          />
        </>
      )}
    </div>
  );
};
